import { Modal } from '@mantine/core'
import { motion } from 'framer-motion'
import { IPhoneNumber } from '../../interface'
import { CloseIcon } from '@forwardflow/icons'

interface DeletePhoneNumberModalProps {
   isOpen: boolean
   onClose: () => void
   onConfirm: () => void
   phoneNumber?: IPhoneNumber
   isLastNumber?: boolean
   isLoading?: boolean
}

export const DeletePhoneNumberModal = ({
   isOpen,
   onClose,
   onConfirm,
   phoneNumber,
   isLastNumber = false,
   isLoading = false,
}: DeletePhoneNumberModalProps) => {
   if (!phoneNumber) return null

   const conversationCount =
      phoneNumber.conversationStats?.totalMessages || 0

   return (
      <Modal
         opened={isOpen}
         onClose={onClose}
         withCloseButton={false}
         centered
         size="sm"
         padding={0}
         styles={{
            content: {
               backgroundColor: 'rgba(0, 0, 0, 0.50)',
               backdropFilter: 'blur(8px)',
               borderRadius: '12px',
            },
            body: {
               padding: 0,
            },
         }}
      >
         <div className="flex flex-col p-8">
            {/* Header */}
            <div className="flex items-center justify-between mb-6">
               <h2 className="text-white text-base font-medium">
                  {isLastNumber
                     ? 'Campaign Pause Alert'
                     : 'Are you sure to remove this number?'}
               </h2>
               <button
                  onClick={onClose}
                  className="text-white/70 hover:text-white transition-colors p-1"
               >
                  <CloseIcon className="w-4 h-4" />
               </button>
            </div>

            {/* Content */}
            <div className="mb-8">
               <p className="text-white/90 text-xs leading-relaxed">
                  {isLastNumber ? (
                     <>
                        Removing this number will result in the campaign having
                        no numbers to work with, Hence the campaign will be
                        paused.
                     </>
                  ) : (
                     <>
                        This Phone Number is used for {conversationCount}{' '}
                        ongoing conversations. You can force delete the number.
                        we will continue contacting the leads with the same
                        number till the end of month and then continue nurturing
                        them with other numbers
                     </>
                  )}
               </p>
            </div>

            {/* Actions */}
            <div className="flex flex-col gap-y-3">
               <motion.button
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                  onClick={onConfirm}
                  disabled={isLoading}
                  className="w-full px-8 py-2 rounded-md border border-[#C11574] bg-[#C11574]/20 text-white font-medium hover:bg-[#C11574]/30 transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-x-2"
               >
                  {isLoading && (
                     <motion.div
                        animate={{ rotate: 360 }}
                        transition={{
                           duration: 1,
                           repeat: Infinity,
                           ease: 'linear',
                        }}
                        className="w-4 h-4 border-2 border-white border-t-transparent rounded-full"
                     />
                  )}
                  {isLoading ? 'Removing...' : 'Remove number'}
               </motion.button>
               <motion.button
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                  onClick={onClose}
                  disabled={isLoading}
                  className="w-full px-8 py-2 rounded-mdimage.png border border-white/20 text-white font-medium hover:bg-white/5 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
               >
                  Cancel
               </motion.button>
            </div>
         </div>
      </Modal>
   )
}
